import { memo } from 'react';
import { DateTimePicker as DateTimePickerLib, Application } from 'react-rainbow-components';
import styles from "./dateTimePicker.module.scss";
import calendarIcon from "@source/assets/imgs/calendar.svg";
import Svg from '../../svg/svg';
import { Colors } from '@source/utils/utils';

/** See https://react-rainbow.io/#/DateTimePicker for more information */
export default memo((props: DateTimePickerProps) => {
  const {onChange, value, className, label, 
        disabled, placeholder, id, maxDate, minDate, required, touched, error} = props;

  const theme = {
    rainbow: {
        palette: {
          brand: Colors.primary01,
        },
    },
  };

  return(
    <div className={`${styles.picker} ${className} ${disabled ? styles.picker_disabled : ''}`}>
      {label
        ? <div className={styles.picker_label}>{label}</div>
        : <></>}

      <Application theme={theme}>
        <DateTimePickerLib
            id={id}
            name={id}
            value={value || undefined}
            maxDate={maxDate}
            minDate={minDate}
            onChange={onChange}
            required={required}
            placeholder={placeholder}
            className={`
              ${styles.picker_inner} 
              ${touched && error ? styles.picker_inner_error : ''}`
            }
            icon={<Svg src={calendarIcon}/>} 
            disabled={disabled}
            locale={'en-gb'}
            formatStyle="medium"/>
      </Application>

      {touched && error
        ? <div className={styles.picker_error}>{error}</div>
        : <></>}
    </div>
  )
});

interface DateTimePickerProps {
  /** DatePicker value */
  value: Date | null,

  /** DatePicker change handler */
  onChange: (x: Date) => void,

  /** className for container wrapping DateInput component */
  className?: string,

  /** DatePicker disabled 
   * @default false
  */
  disabled?: boolean,

  /** DatePicker label */
  label?: string,

  /** DatePicker placeholder */
  placeholder?: string,

  /** DatePicker id */
  id?: string,

  /** Last day user can set */
  maxDate?: Date,

  /** First day user can set */
  minDate?: Date,

  /** Is date required */
  required?: boolean,

  /** Input error message */
  error?: string,

  /** Input touched */
  touched?: boolean,
}